import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Separator } from '../components/ui/separator';
// import { MailIcon } from '../components/ui/icons';
import LumpenLogo from '../components/LumpenLogo';
import CustomSpace from '../components/ui/CustomSpace';

/**
 * FOOTER
 *
 * @author hjkim
 * @constructor
 */

const Footer = () => {
  /**
   * Hooks
   */
  /* navigator */
  // const navigate = useNavigate();

  /**
   * Handlers
   */
  /* 페이지 이동 handler */
  // const navigateTo = (moveTo: string) => {
  //   navigate(moveTo);
  // };

  const APP_VERSION = 'v1.1.0';

  return (
    <footer className="bg-card border-t border-border mt-auto">
      {/* Main Footer Content - Hidden on mobile when bottom nav is present */}
      <div className="hidden md:block">
        <div className="container mx-auto px-4 py-2">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* App Info */}
              <div className="">
                <div className="flex items-center gap-3">
                  <LumpenLogo size="lg" h-14 />
                  <div>
                    <p className="text-sm text-muted-foreground">{APP_VERSION}</p>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                </p>
              </div>

              {/* Contact & Info */}
              <div className="space-y-4">
                <h4 className="font-medium mt-10">정보</h4>
                <div className="space-y-4 text-sm">
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <Mail className="h-4 w-4" />
                    <span>문의: 20220330jin@gmail.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator />

        {/* Bottom Bar */}
        <div className="container mx-auto px-4 py-6">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
              <div className="flex items-center gap-4">
                <p>© 2025 Lumpen. All rights reserved.</p>
              </div>
              <div className="flex items-center gap-4">
                <Separator orientation="vertical" className="h-4" />
                <Link to="/legal/privacy-policy" className="hover:text-foreground transition-colors">
                  개인정보처리방침
                </Link>
                <Separator orientation="vertical" className="h-4" />
                <Link to="/legal/terms" className="hover:text-foreground transition-colors">
                  이용약관
                </Link>
                <Separator orientation="vertical" className="h-4" />
                <Link to="/admin/inquiry" className="hover:text-foreground transition-colors cursor-pointer">
                  문의하기
                </Link>
                <Separator orientation="vertical" className="h-4" />
                <Link to="/withdraw" className="hover:text-destructive transition-colors cursor-pointer">
                  탈퇴하기
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Footer - Minimal version that shows above bottom navigation */}
      <div className="md:hidden bg-muted/30 mb-4">
        <CustomSpace hSize="xl2" />
      </div>
    </footer>
  );
};
export default Footer;
